// removed by extract-text-webpack-plugin
module.exports = {"component":"Style__component___1EWPk","innerFlex":"Style__innerFlex___2KFbW"};


//////////////////
// WEBPACK FOOTER
// ./client/components/layout/CenterSpinner/Style.css
// module id = 2036
// module chunks = 0